import { UserPreferencesState } from './state';
import {
  UserPreferencesActionsUnion,
  UserPreferencesActionTypes,
  SaveUserPreferenceSuccess,
} from './actions';
import { UserPreference, FilterSet } from '../../types/user-preferences.types';

export const userPreferencesDefaultState: UserPreferencesState = {
  userPreferences: [],
  loaded: false,
  loading: false,
  saving: false,
  error: undefined,
};

export function userPreferencesReducer(
  state = userPreferencesDefaultState,
  action: UserPreferencesActionsUnion
): UserPreferencesState {
  switch (action.type) {
    case UserPreferencesActionTypes.Load:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case UserPreferencesActionTypes.LoadSuccess:
      return {
        ...state,
        userPreferences: action.payload,
        loaded: true,
        loading: false,
        error: undefined,
      };
    case UserPreferencesActionTypes.LoadFail:
      return {
        ...state,
        userPreferences: [],
        loaded: false,
        loading: false,
        error: action.payload,
      };
    case UserPreferencesActionTypes.Save:
      return {
        ...state,
        saving: true,
      };
    case UserPreferencesActionTypes.SaveSuccess:
      // eslint-disable-next-line no-case-declarations
      const saveSuccessAction = action as SaveUserPreferenceSuccess;
      return {
        ...state,
        userPreferences: [...state.userPreferences, saveSuccessAction.payload],
        saving: false,
      };
    case UserPreferencesActionTypes.SaveFail:
      return {
        ...state,
        saving: false,
      };
    case UserPreferencesActionTypes.Delete:
      return {
        ...state,
        saving: true,
      };
    case UserPreferencesActionTypes.DeleteSuccess:
      return {
        ...state,
        userPreferences: action.payload,
        saving: false,
      };
    case UserPreferencesActionTypes.DeleteFail:
      return {
        ...state,
        saving: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

export const getSavedCalendarFilters = (
  userPrefState: UserPreferencesState
): FilterSet[] => {
  return userPrefState.userPreferences.map((pref: UserPreference) => ({
    id: pref.id,
    name: pref.name,
    filterSet: pref.userPreference['calendarFilters'],
  }));
};
